<template>
  <div style="height:300px;position:relative;">
    <div class="table-list2">
      <span class="list-key">注解</span>
      <span style="display: inline-block;margin: 0 6px;line-height:40px;float:left">:</span>
      <span class="list-val" style="float:left;">
        <el-input 
          :style="input_width" 
          :autosize="{ minRows: 9, maxRows: 12}" 
          type="textarea"  
          :rows="2" 
          :placeholder="$t('message.placeholder.input')"
          v-model="signoffComments">
        </el-input>
      </span>
    </div>
    <div class="table-list2 tableBtn">
      <el-button @click="submit">确认</el-button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
			signoffComments: "",
      input_width: {
					width: "96%"
				},
      
    }
  },
  methods:{
    submit() {

        var session = window.sessionStorage.getItem('userContext');
				const {id,loginId} = JSON.parse(session);
				const user = {id,loginId,type:1};

				var request = { //post更改的值
					objectId: {
						// ... this.$store.state.objectId,
					},
					status: this.title_currentStatusId,
					// approvers: approversInRequest,
					approvers: [user],
					comments: this.signoffComments,
				};
        this.$emit('subData',request)
        
			},
  },
}
</script>

<style scoped>
	.tableBtn {
		position: absolute;
		bottom: 0;
		right: 0;
	}

	.table-list2 {
		overflow: auto;
		margin-top: 4px;
	}

	.table-list2 .list-key {
		display: inline-block;
		width: 22%;
		text-align: right;
		font-size: 14px;
		line-height: 40px;
		float: left;
	}

	.table-list2 .list-val {
		display: inline-block;
		width: 60%;
		overflow: hidden;
	}
</style>